import React from "react";
import MultiJobPopup from "./MultiJobPopup";
import Label from "../../FormComponents/Label";

// const PostActionJob = ({ postJobData, onChange, smId, device, type }) => {
const PostActionJob = ({ postJobData, onChange, smId, device, type, templateObject, allJobs }) => {
  const updateJobs = (key, updatedJobs) => {
    onChange({
      ...postJobData,
      [key]: updatedJobs
    });
  };

  return (
    <div className="d_flex flex_column gap_2">
      {Object.keys(postJobData).map((key) => {
        const jobsArray = postJobData[key];
        return (
          <div className="job-section" key={key}>
            <Label>{key.split("_").join(" ")}</Label>
            <MultiJobPopup
              jobConfig={jobsArray || []}
              onChange={(updatedJobs) => updateJobs(key, updatedJobs)}
              allJobs={allJobs}
              smId={smId}
              device={device}
              type={type}
              templateObject={templateObject}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PostActionJob;

// const postJobData = {
//   success_jobs: [
//     {
//       id: "66ffc9f3c5b79e5e7f17c213",
//       job_id: "657b0b48c7c9d4d3e83e22a0",
//       job_template: "navigate",
//       params: {
//         name: "page1"
//       }
//     },
//     {
//       id: "66ffc9f8c5b79e5e7f17c218",
//       job_id: "657c3e12afa7b4e002b01277",
//       job_template: "register_entity",
//       params: {
//         entity_id: "66ed23ecfda9fdc24aa0b4de"
//       }
//     }
//   ],
//   faliure_jobs: [
//     {
//       id: "66ffc9f3c5b79e5e7f17c213",
//       job_id: "657b0b48c7c9d4d3e83e22a0",
//       job_template: "navigate",
//       params: {
//         name: "page1"
//       }
//     },
//     {
//       id: "66ffc9f8c5b79e5e7f17c218",
//       job_id: "657c3e12afa7b4e002b01277",
//       job_template: "register_entity",
//       params: {
//         entity_id: "66ed23ecfda9fdc24aa0b4de"
//       }
//     }
//   ]
// };
